import Vue from 'vue';
import moment from 'moment';
import { initialState } from './state';
import { parseResponseError } from '../../helpers/errors';

function buildFormation(formation, formations, matchPlayers = null) {
  const players = formation.players.reduce((result, player) => {
    const playerName =
      matchPlayers && matchPlayers[player.order] ? matchPlayers[player.order].fullName : '';
    result[player.pivot.order] = {
      id: player.id,
      order: player.order,
      text: matchPlayers ? playerName : player.name,
      value: matchPlayers ? player.playerId : player.order,
    };

    if (player.avatarUrls) result[player.pivot.order].avatarUrls = player.avatarUrls;

    return result;
  }, {});

  return {
    id: formation.id,
    teamFormation: formations.find(item => item.id === formation.formation.id),
    players,
    canvas: formation.canvas,
    canvasImage: formation.canvasImage,
  };
}

export default {
  handleError(state, err) {
    const errorMessage = parseResponseError(err);
    state.errors.form = errorMessage;
  },

  setEditorDialog(state, value) {
    state.editorDialog = value;
  },
  SetConvocatedPlayersBasedonRole(state, value) {
    state.ConvocatedPlayersBasedonRole = JSON.parse(JSON.stringify(value));
  },
  setMatchId(state, value) {
    state.matchId = value;
  },
  // #region Setters

  players(state, { players, match }) {
    state.players = players.players
      .map(p => {
        let status = '';

        switch (p.infos[0].status) {
          case 0:
            status = ' (Trasferito)';
            break;
          case 1:
            status = ' (Ceduto)';
            break;
          default:
            status = '';
        }

        return {
          ...p,
          fullName: `${p.fullName}${status}`,
        };
      })
      .sort((a, b) => {
        const nameA = a.fullName.toUpperCase();
        const nameB = b.fullName.toUpperCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });

    if (!match) {
      state.players = state.players.filter(p => [2, 3].includes(p.infos[0].status));
    }

    state.players.forEach(player => {
      Vue.set(
        state.form.convocations,
        player.id,
        player.convocated !== undefined && player.convocated !== null ? player.convocated : true,
      );
    });

    state.form.convocationPlace = players.convocationPlace;
  },

  formations(state, formations) {
    state.formations = formations;
  },

  match(state, match) {
    state.match = match;
  },

  exportCanvas(state, { key, json }) {
    if (!key || !state.form[key]) return;

    state.form[key].canvas = json;
  },

  exportCanvasImage(state, { key, image }) {
    if (!key || !state.form[key]) return;

    state.form[key].canvasImage = image;
  },

  exportKickCanvas(state, { index, json }) {
    state.form.kicks[index].canvas = json;
  },

  exportKickCanvasImage(state, { index, image }) {
    state.form.kicks[index].canvasImage = image;
  },

  playedAt(state, payload) {
    if (payload) {
      const date = moment.unix(payload / 1000);
      state.form.playedAt = moment()
        .year(date.year())
        .month(date.month())
        .date(date.date())
        .toISOString();
    } else {
      state.form.playedAt = moment().toISOString();
    }
  },

  // #endregion

  // #region Form

  formInput(state, { name, value }) {
    if (name.includes('.')) {
      state.form[name.split('.')[0]][name.split('.')[1]] = value;
    } else {
      state.form[name] = value;
    }

    if (name === 'type' && state.form.type !== 0 && state.form.day !== null) state.form.day = null;

    if (name === 'players') {
      if (state.form.homeModule.teamFormation) {
        state.form.homeModule.teamFormation = null;
        state.form.homeModule.players = [];
      }
      if (state.form.homeModule2.teamFormation) {
        state.form.homeModule2.teamFormation = null;
        state.form.homeModule2.players = [];
      }
      if (state.form.opponentModule.teamFormation) {
        state.form.opponentModule.teamFormation = null;
        state.form.opponentModule.players = [];
      }
    }
  },

  setConvocatedPlayer(state, { id, convocated }) {
    if (state.form.convocations[id] === undefined) return;

    state.form.convocations = {
      ...state.form.convocations,
      [id]: convocated || false,
    };

    if (convocated === false) {
      Object.entries(state.form.homePlayers).forEach(([order, player]) => {
        if (player.playerId === id) {
          Vue.delete(state.form.homePlayers, Number(order));
        }
      });
    }
  },

  setConvocationPlace(state, place) {
    state.form.convocationPlace = place;
  },

  setPlayersNumber(state) {
    state.homeMatchPlayersNumber = Object.keys(state.form.convocations).filter(
      c => state.form.convocations[c],
    ).length;
  },

  addKick(state) {
    state.form.kicks.push({
      name: null,
      canvas: null,
      canvasImage: null,
    });
  },

  setKickInput(state, { index, name, value }) {
    Vue.set(state.form.kicks[index], name, value);
  },

  removeKick(state, index) {
    state.form.kicks.splice(index, 1);
  },

  playedAtDateInput(state, payload) {
    const date = moment(payload);
    state.form.playedAt = moment(state.form.playedAt)
      .year(date.year())
      .month(date.month())
      .date(date.date())
      .toISOString();
  },

  playedAtTimeInput(state, payload) {
    const tokens = payload.split(':');
    state.form.playedAt = moment(state.form.playedAt)
      .hour(tokens[0])
      .minute(tokens[1])
      .toISOString();
  },

  // #region Players

  addHomePlayer(state, { order, player }) {
    Vue.set(state.form.homePlayers, order, {
      playerId: player.playerId,
      fullName: player.fullName,
      rating: 0,
      avatarUrls: player.avatarUrls,
      order,
      shirt: player.shirt,
    });
  },

  addRatingToHomePlayer(state, { order, rating }) {
    if (!state.form.homePlayers[order]) return;

    state.form.homePlayers[order].rating = rating;
  },

  removeHomePlayer(state, order) {
    Vue.delete(state.form.homePlayers, order);

    state.form.homeGoals.forEach((g, index) => {
      if (g.matchPlayerId === order) {
        state.form.homeGoals.splice(index, 1);
      }
    });

    state.form.homeAdmonitions.forEach((a, index) => {
      if (a.matchPlayerId === order) {
        state.form.homeAdmonitions.splice(index, 1);
      }
    });

    state.form.homeExpulsions.forEach((e, index) => {
      if (e.matchPlayerId === order) {
        state.form.homeExpulsions.splice(index, 1);
      }
    });

    state.form.homeSubstitutions.forEach((s, index) => {
      if (s.enteringMatchPlayerId === order || s.leavingMatchPlayerId === order) {
        state.form.homeSubstitutions.splice(index, 1);
      }
    });
  },

  setShirtToHomePlayer(state, { order, shirt }) {
    if (!state.form.homePlayers[order]) return;

    state.form.homePlayers[order].shirt = shirt;
  },

  setShirtToOpponentPlayer(state, { order, shirt }) {
    if (!state.form.opponentPlayers[order]) return;

    state.form.opponentPlayers[order].shirt = shirt;
  },

  addOpponentPlayer(state, { order, name, shirt }) {
    Vue.set(state.form.opponentPlayers, order, { order, name, shirt });
  },

  removeOpponentPlayer(state, order) {
    Vue.delete(state.form.opponentPlayers, order);

    state.form.opponentGoals.forEach((g, index) => {
      if (g.matchPlayerId === order) {
        state.form.opponentGoals.splice(index, 1);
      }
    });

    state.form.opponentAdmonitions.forEach((a, index) => {
      if (a.matchPlayerId === order) {
        state.form.opponentAdmonitions.splice(index, 1);
      }
    });

    state.form.opponentExpulsions.forEach((e, index) => {
      if (e.matchPlayerId === order) {
        state.form.opponentExpulsions.splice(index, 1);
      }
    });

    state.form.opponentSubstitutions.forEach((s, index) => {
      if (s.enteringMatchPlayerId === order || s.leavingMatchPlayerId === order) {
        state.form.opponentSubstitutions.splice(index, 1);
      }
    });
  },

  addHomeMatchPlayerInput(state) {
    state.homeMatchPlayersNumber += 1;
  },
  subtractHomeMatchPlayerInput(state) {
    state.homeMatchPlayersNumber -= 1;
  },
  subtractOpponentMatchePlayers(state) {
    state.opponentMatchPlayersNumber -= 1;
  },
  addOpponentMatchPlayerInput(state) {
    state.opponentMatchPlayersNumber += 1;
  },

  convocationPlace(state, place) {
    Vue.set(state, 'convocationPlace', place);
  },

  // #endregion

  // #region Modules

  homeModuleInput(state, { name, value }) {
    state.form.homeModule[name] = value;
    if (name === 'teamFormation') state.form.homeModule.players = {};
  },

  homeModule2Input(state, { name, value }) {
    state.form.homeModule2[name] = value;
    if (name === 'teamFormation') state.form.homeModule2.players = {};
  },

  homeModulePlayersInput(state, { index, value }) {
    Vue.set(state.form.homeModule.players, index, value);
  },

  homeModule2PlayersInput(state, { index, value }) {
    Vue.set(state.form.homeModule2.players, index, value);
  },

  opponentModuleInput(state, { name, value }) {
    state.form.opponentModule[name] = value;
    if (name === 'teamFormation') state.form.opponentModule.players = {};
  },

  opponentModulePlayersInput(state, { index, value }) {
    Vue.set(state.form.opponentModule.players, index, value);
  },

  // #endregion

  // #endregion

  paginate(state, pagination) {
    state.pagination = pagination;
  },

  reset(state) {
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },

  setHomeMatchPlayersNumber(state) {
    state.homeMatchPlayersNumber = Math.max(
      Math.max(...Object.keys(state.form.homePlayers).map(p => Number(p))),
      Object.keys(state.form.convocations).filter(c => state.form.convocations[c]).length,
    );
  },

  buildForm(state, match) {
    const form = {
      type: 0,
      duration: 90,
      players: 11,
      opponentName: '',
      playedAt: '',
      home: true,
      scuolaCalcio: false,
      day: null,
      notes: '',
      kicks: [],
      homePlayers: {},
      opponentPlayers: {},
      homeModule: {
        teamFormation: null,
        players: {},
        canvas: null,
        canvasImage: null,
      },
      homeModule2: {
        teamFormation: null,
        players: {},
        canvas: null,
        canvasImage: null,
      },
      opponentModule: {
        teamFormation: null,
        players: {},
        canvas: null,
        canvasImage: null,
      },
      homeGoals: [],
      opponentGoals: [],
      homeSubstitutions: [],
      opponentSubstitutions: [],
      homeAdmonitions: [],
      opponentAdmonitions: [],
      homeExpulsions: [],
      opponentExpulsions: [],
      convocationPlace: state.form.convocationPlace,
      convocations: state.form.convocations || {},
      distinctInfos: {
        championship: null,
        place: null,
        captainId: null,
        viceId: null,
        assistant: null,
        manager: null,
        manager2: null,
        doctor: null,
        coach: null,
        coach2: null,
        massagist: null,
        notes: null,
        company: null,
      },
    };

    const homePlayerIds = match.matchPlayers
      .filter(p => p.order !== 0 && p.playerId)
      .map(p => p.playerId);

    function awayPlayerFilter(p) {
      const { status } = p.infos[0];

      return [2, 3].includes(status) || homePlayerIds.includes(p.id);
    }

    state.players = state.players.filter(awayPlayerFilter);

    form.type = match.type;
    form.duration = match.duration;
    form.players = match.players;
    form.opponentName = match.opponentName;
    form.playedAt = moment(match.playedAt, 'YYYY-MM-DD HH:mm').toISOString();
    form.home = match.home === 1;
    form.scuolaCalcio = match.scuolaCalcio === 1;
    form.day = match.day;
    form.notes = match.notes;
    form.kicks = match.kicks;
    if (match.info) {
      form.distinctInfos = match.info;
      if (match.info.captain) {
        form.distinctInfos.captainId = match.info.captain.order;
      }
      if (match.info.vice) {
        form.distinctInfos.viceId = match.info.vice.order;
      }
    }
    const hasOrder0 = match.matchPlayers.find(p => p.order === 0 && p.playerId);

    match.matchPlayers.forEach(player => {
      const order = hasOrder0 ? player.order + 1 : player.order;
      const matchPlayer = {
        id: player.id,
        order,
        shirt: player.shirt,
      };

      if (player.home) {
        matchPlayer.playerId = player.playerId;
        matchPlayer.rating = player.rating || 0;
        matchPlayer.fullName = player.player && player.player.fullName;
        matchPlayer.avatarUrls = player.player && player.player.avatarUrls;
        if (!form.homePlayers[order]) form.homePlayers[order] = matchPlayer;
      } else {
        matchPlayer.name = player.name;
        if (!form.opponentPlayers[order]) form.opponentPlayers[order] = matchPlayer;
      }
    });

    state.homeMatchPlayersNumber = Math.max(
      Math.max(...Object.keys(form.homePlayers).map(p => Number(p))),
      Object.keys(form.convocations).filter(c => form.convocations[c]).length,
    );
    state.opponentMatchPlayersNumber = Math.max(
      match.players,
      Object.keys(form.opponentPlayers).length - 1,
    );

    const homeModule = match.matchFormations.find(item => item.type === 0);
    if (homeModule)
      form.homeModule = buildFormation(homeModule, state.formations, form.homePlayers);

    const homeModule2 = match.matchFormations.find(item => item.type === 2);
    if (homeModule2)
      form.homeModule2 = buildFormation(homeModule2, state.formations, form.homePlayers);

    const opponentModule = match.matchFormations.find(item => item.type === 1);
    if (opponentModule) form.opponentModule = buildFormation(opponentModule, state.formations);

    match.goals.forEach(goal => {
      const goalData = {
        minute: goal.minute,
        matchPlayerId: goal.player.order,
        autogoal: goal.autogoal,
        type: goal.type,
      };

      form[goal.player.playerId ? 'homeGoals' : 'opponentGoals'].push(goalData);
    });

    match.substitutions.forEach(substitution => {
      const substitutionData = {
        minute: substitution.minute,
        leavingMatchPlayerId: substitution.leavingPlayer.order,
        enteringMatchPlayerId: substitution.enteringPlayer.order,
      };

      form[
        substitution.leavingPlayer.playerId ? 'homeSubstitutions' : 'opponentSubstitutions'
      ].push(substitutionData);
    });

    match.admonitions.forEach(admonition => {
      const admonitionData = {
        minute: admonition.minute,
        matchPlayerId: admonition.player.order,
      };

      form[admonition.player.playerId ? 'homeAdmonitions' : 'opponentAdmonitions'].push(
        admonitionData,
      );
    });

    match.expulsions.forEach(expulsion => {
      const expulsionData = {
        minute: expulsion.minute,
        matchPlayerId: expulsion.player.order,
      };

      form[expulsion.player.playerId ? 'homeExpulsions' : 'opponentExpulsions'].push(expulsionData);
    });

    state.form = form;
  },

  selectCaptain(state, value) {
    state.form.distinctInfos.captainId = value;
  },

  selectViceCaptain(state, value) {
    state.form.distinctInfos.viceId = value;
  },
};



// WEBPACK FOOTER //
// ./src/store/matches/mutations.js